import { render, staticRenderFns } from "./InfectedFile.vue?vue&type=template&id=54ebda35"
import script from "./InfectedFile.vue?vue&type=script&lang=js"
export * from "./InfectedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports